module.exports = __webpack_public_path__ + "img/landing-icon.1729f48a.png";